import ODataModel from "sap/ui/model/odata/v4/ODataModel";
import OrderLabelDefinition from "ips/ac/data/order/label/definition/OrderLabel";
import FlowComponent from "ips/ac/Component";
import JSONModel from "sap/ui/model/json/JSONModel";
import Util from "ips/ac/util/Util";
import { OrderLabel } from "ips/ac/model/odata/generated/IpsCoreModel";
import ODataListBinding from "sap/ui/model/odata/v4/ODataListBinding";
import Context from "sap/ui/model/odata/v4/Context";

export default class OrderLabelService {

  public static async refreshOrderLabelModel():Promise<OrderLabel[]>{
    const component:FlowComponent= Util.getComponent() as FlowComponent;
    const model:ODataModel =  component.getModel() as ODataModel;

    const context:ODataListBinding = model.bindList("/"+ OrderLabelDefinition.ENTITY_SET, null, null,null, {$select: "BackgroundColor,Text,FontColor,Guid"});
    const orderLabelContexts:Context[] = await context.requestContexts(0,Infinity);
    const orderLabels:OrderLabel[] = orderLabelContexts.map((context:Context) => context.getObject());

    const orderLabelModel:JSONModel = component.getModel("OrderLabels") as JSONModel;
    orderLabelModel.setProperty("/", orderLabels);

    return orderLabels;
  }
}